import { Component, OnInit, signal, WritableSignal, inject } from '@angular/core';
import { NgClass, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { DashboardApiService } from '../../../../../_services/dashboard-api-service/dashboard-api.service';
import { Router, RouterLink } from '@angular/router';
import { DashboardWidgetBaseComponent } from '../dashboard-widget-base.component';
import { AccountingApiService } from '../../../../../_services/accounting-service/accounting-api/accounting-api.service';
import { AccountingProvider, AccountingProviderCompany } from '../../../../../_interfaces/accounting.interface';
import { HttpParams } from '@angular/common/http';
import { updateParamsObject } from '@bo/ng-utils';
import { TransactionStatus } from '../../../../../_interfaces/transactions.interface';

@Component({
  selector: 'app-accounting-software-widget',
  imports: [NgOptimizedImage, RouterLink, NgClass, NgTemplateOutlet],
  templateUrl: './accounting-software-widget.component.html',
})
export class AccountingSoftwareWidgetComponent extends DashboardWidgetBaseComponent implements OnInit {
  readonly dashboardApiService = inject(DashboardApiService);
  readonly accountingApiService = inject(AccountingApiService);
  readonly router = inject(Router);

  protected hasAccounting = signal(false);
  protected unsyncedTransactions: WritableSignal<number | null> = signal(null);
  protected providers: WritableSignal<AccountingProvider[]> = signal([]);
  protected readonly AccountingProviderCompany = AccountingProviderCompany;

  ngOnInit() {
    this.subscriptions.add(
      this.accountingApiService.getAccountingProviders().subscribe({
        next: (res) => {
          if (res) {
            this.providers.set(res);
            this.isLoading = false;
          }
        },
      }),
    );

    this.subscriptions.add(
      this.dashboardApiService.getAccountingWidgetDetails().subscribe({
        next: (res) => {
          if (res) {
            this.unsyncedTransactions.set(res.unsynced_transactions);
            this.hasAccounting.set(res.has_accounting);
            this.isLoading = false;
          }
        },
        error: (error) => {
          this.hasAccounting.set(error?.status !== 400);
          this.isLoading = false;
        },
      }),
    );
  }

  navigateToTransactions() {
    const params = new HttpParams().append(
      'status',
      TransactionStatus.READY + ',' + TransactionStatus.ERROR + ',' + TransactionStatus.NEW,
    );
    this.router.navigate(['/accounting/transactions'], { queryParams: updateParamsObject(params) });
  }
}
